import { trimSearch } from '@xmatters/common/utils/searchUtil';
import bluebird from 'utils/bluebird';
import { getListingURIGenerator } from '@xmatters/redux/actions/listPage/utils';

export const SEARCH_DEVICE_NAMES_LIST_PAGE = 'SEARCH_DEVICE_NAMES';
export const SEARCH_DEVICE_NAMES_LIST_PAGE_SUCCESS = `${SEARCH_DEVICE_NAMES_LIST_PAGE}_SUCCESS`;
export const SEARCH_DEVICE_NAMES_LIST_PAGE_FAIL = `${SEARCH_DEVICE_NAMES_LIST_PAGE}_FAIL`;
export const SEARCH_DEVICE_NAMES_LIST_PAGE_START = `${SEARCH_DEVICE_NAMES_LIST_PAGE}_START`;
export const DELETE_DEVICE_NAME = 'DELETE_DEVICE_NAME';
export const DELETE_DEVICE_NAME_SUCCESS = `${DELETE_DEVICE_NAME}_SUCCESS`;
export const DELETE_DEVICE_NAME_FAIL = `${DELETE_DEVICE_NAME}_FAIL`;
export const GET_DEVICES_USING_DEVICE_NAMES_COUNT =
  'GET_DEVICES_USING_DEVICE_NAMES_COUNT';
export const GET_DEVICES_USING_DEVICE_NAMES_COUNT_SUCCESS = `${GET_DEVICES_USING_DEVICE_NAMES_COUNT}_SUCCESS`;
export const GET_DEVICES_USING_DEVICE_NAMES_COUNT_FAIL = `${GET_DEVICES_USING_DEVICE_NAMES_COUNT}_FAIL`;

export const UPDATE_DEVICE_NAME = 'UPDATE_DEVICE_NAME';
export const UPDATE_DEVICE_NAME_START = `${UPDATE_DEVICE_NAME}_START`;
export const UPDATE_DEVICE_NAME_SUCCESS = `${UPDATE_DEVICE_NAME}_SUCCESS`;
export const UPDATE_DEVICE_NAME_FAIL = `${UPDATE_DEVICE_NAME}_FAIL`;

export const CLEAR_UPDATE_DEVICE_NAME = `CLEAR_${UPDATE_DEVICE_NAME}`;

export const DEVICE_NAMES_URI = '/webapi/xm/1/device-names';
export const DEVICES_URI = '/webapi/xm/1/devices';

export const getSearchFilterParams = props => {
  const { startIndex = 0, stopIndex = 0, search, sortBy, sortOrder } = props;

  const type = props.deviceTypes?.value;
  const sortOptions = {
    name: 'NAME',
  };

  const params = {
    limit: 100,
    offset: 0,
  };

  params.limit = Math.max(100, stopIndex - startIndex);
  params.offset = startIndex;

  if (sortBy && sortOrder) {
    params.sortBy = sortOptions[sortBy];
    params.sortOrder = sortOrder;
  }

  const trimmedSearchText = trimSearch(search);
  if (trimmedSearchText.length >= 2) {
    params.search = trimmedSearchText;
    params.operand = 'AND';
  }

  if (type && type.length) {
    params.deviceTypes = type;
  }

  return params;
};

export const deleteDeviceName = deviceNameId => {
  return {
    type: DELETE_DEVICE_NAME,
    meta: {
      xmApi: true,
      method: 'del',
      uri: `${DEVICE_NAMES_URI}/${deviceNameId}`,
    },
  };
};

export const deleteDeviceNames = deviceNames => dispatch => {
  return bluebird.each(deviceNames, deviceName =>
    dispatch(deleteDeviceName(deviceName)),
  );
};

export const searchDeviceNames = (props = {}) => {
  const params = getSearchFilterParams(props);

  return {
    type: SEARCH_DEVICE_NAMES_LIST_PAGE,
    meta: {
      xmApi: true,
      method: 'get',
      uri: DEVICE_NAMES_URI,
      params,
      customUriWithParamsGenerator: getListingURIGenerator,
    },
  };
};

export const getDevicesUsingDeviceNameCount = names => {
  return {
    type: GET_DEVICES_USING_DEVICE_NAMES_COUNT,
    meta: {
      xmApi: true,
      method: 'get',
      uri: DEVICES_URI,
      params: {
        deviceNames: names.join(','),
      },
      isUriEncoded: true,
      customUriWithParamsGenerator: getListingURIGenerator,
    },
  };
};

export const DEVICE_NAMES_LIST_PAGE_SET_LOADING =
  'DEVICE_NAMES_LIST_PAGE_SET_LOADING';
export const setIsLoading = () => ({
  type: DEVICE_NAMES_LIST_PAGE_SET_LOADING,
});

export const updateDeviceName = (params = {}) => ({
  type: UPDATE_DEVICE_NAME,
  meta: {
    xmApi: true,
    uri: `/webapi/xm/1/device-names`,
    method: 'post',
    params,
  },
});

export const clearUpdatedDevice = () => ({
  type: CLEAR_UPDATE_DEVICE_NAME,
});
